export default __webpack_public_path__ + "static/media/mark.b4484592.png";